import { DraftStyleMap } from 'draft-js'
import { Options } from 'draft-js-export-html'
import { stripHTML } from './dataTransformer'

// eslint-disable-next-line import/prefer-default-export
export const maxCharsDisplay = (
  count?: number,
  limit?: number,
): string | null => {
  if (limit) {
    const remaining = limit - (count || 0)

    if (remaining <= 0) return 'No characters left'

    return `${count ? remaining : limit} character${remaining === 1 ? '' : 's'
      } left`
  }
  return null
}

export const maxLinesDisplay = (
  count?: number,
  limit?: number,
): string | null => {
  if (limit) {
    const remaining = limit - (count || 0)

    if (remaining <= 0) return 'No lines left'

    return `${count ? remaining : limit} line${remaining === 1 ? '' : 's'} left`
  }
  return null
}

export const hasForbiddenChars = (input: string): boolean => {
  // ^ NOT all of the below
  // \p{L} matches any kind of letter from any language
  // \p{N} matches any kind of numeric character in any script
  // \s matches any kind of space
  // \x00-\x7F matches any ASCII character
  // \p{Sc} matches any kind of currency symbol
  // \p{P} matches any kind of punctuation character
  // eslint-disable-next-line no-control-regex
  const regEx = /[^\p{L}\p{N}\s\x00-\x7F\p{Sc}\p{P}]/gu
  return regEx.test(input)
}

export const getChars = (input: string): number => {
  const result = stripHTML(input).replaceAll(/\r\n|\r|\n/g, '').length
  return result
}

export const customFontSizes = (
  smallest: number,
  largest: number,
): [DraftStyleMap, Options] => {
  const fontStyleMap: DraftStyleMap = {}
  const fontCustomStyles: Options = { inlineStyles: {} }

  for (let i = smallest; i <= largest; i += 1) {
    const fontSizeValue = `${i}px`
    fontStyleMap[`FONT${i}`] = { fontSize: fontSizeValue }
    if (fontCustomStyles.inlineStyles) {
      fontCustomStyles.inlineStyles[`FONT${i}`] = {
        style: { fontSize: fontSizeValue },
      }
    }
  }

  return [fontStyleMap, fontCustomStyles]
}

export const getFontKeyBySize = (
  fontMap: DraftStyleMap,
  size: string | undefined,
): string | undefined => {
  const fontKey = Object.keys(fontMap).find(
    (key) => fontMap[key].fontSize === size,
  )
  return fontKey || undefined
}

export const getFontSizeFromHTML = (html: string): string | undefined => {
  const regex = /font-size:\s*(\d+px)/
  const match = html.match(regex)
  return match ? match[1] : undefined
}
